import { appConfigFactory } from './appConfig.factory';
import { windowFactory } from './window.factory';

export { appConfigFactory, windowFactory };
